import React from "react";
import { connect } from "react-redux";
import getApiMessage from "assets/scripts/utils/getApiMessage";
const ApiMessage = ({ locale, value, valueES }) => (<span>
		{getApiMessage(locale, value, valueES)}
	</span>);
export default connect((state) => ({
    locale: state.i18n.locale
}))(ApiMessage);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/ApiMessage/ApiMessage.tsx